export default "__VITE_ASSET__Bi71umOg__"